import { __assign } from "tslib";
import { downTimeBuilder, tenantScheduleBuilder } from '../../domain/common/tenant-schedule/tenant-schedule.builder';
import { WebNotificationType, OldWidgetBuilder, WidgetBuilder, widgetIconKeys, WidgetAppearanceSettingsBuilder, WidgetPosition, GroupBuilder, UserInfoBuilder, TicketBuilder, ReplyBuilder, NoteBuilder, SavedReplyBuilder, MailboxBuilder, FacebookPageBuilder, FacebookPageDataBuilder, FacebookPagePluginBuilder, PresenceInfoBuilder, ApiKeyBuilder, WebhookType, WebhookBuilder, UserNotificationBuilder, LabelBuilder, UserBuilder, PermissionLevel, CategoryBuilder, ExtendedCategoryBuilder, RemoteFileBuilder, ContentTaskStatus, ContentTaskBuilder, ContentTaskType, ContentTaskPriority, CustomFieldType, CustomFieldLocaleDataBuilder, ResolvedCustomFieldBuilder, QueueBuilder, QueueStatsBuilder, LineBuilder, CallCenterAgentBuilder, ExtendedCallStatus, CallStatsBuilder, AgentBuilder, ArticleBuilder, ExtendedArticleBuilder, WidgetModuleTransition, AnswersClients, CallParticipantStatus, WebNotificationBuilder, CallCenterAgentStatus, SkillBuilder } from '../..';
import { randomTitle, TsUtils } from '..';
import { CompanyBuilder } from '../../company';
import { SimpleCustomFieldBuilder, ActivityEventBuilder, ItemType, ActivityEventType, ArticleResolution, ArticleType, PublicationStatus, ArticleStatus, AgentChannel, TicketStatus, CallStatsStatus, Channel, TicketPriority, SupportedFeatures, TicketSessionStatus, InstagramAccountBuilder, AgentStatusFilterOptions, ActivityType, CustomFieldBuilder, AutoRoutingAssignmentStatus, AutoRoutingAssignmentBuilder, SkillType, routingFilterBuilder, RoutingFilterType, TicketInfoBuilder } from '../../domain';
import { ArticleVersionBuilder } from '../../domain/kb/articles/article-version.builder';
import { MacroBuilder } from '../../macros/macro.builder';
import { UserRoleBuilder } from '../../roles/roles.builder';
import { RoleInfoBuilder } from '../../roles/roles-info.builder';
import { BrandBuilder } from '../../domain/brands/builders';
import { v4 as uuid } from 'uuid';
import { TicketSummaryChannel } from '../../domain/tickets/ticket-summary.i';
// tslint:disable-next-line:max-line-length
var lorem = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
var loremParts = lorem.split(/\w/);
// tslint:disable-next-line:max-line-length
var names = ['Bob', 'Jacob', 'Sima', 'Mazal', 'Uncle', 'Dod', 'Yasha', 'Yoshi', 'Daniel', 'Nimrod', 'Aaron', 'Gabi', 'Asaf', 'Boris', 'Tali', 'Adam', 'Itay', 'Elad', 'Zohar', 'Gil', 'Guy', 'Rami', 'Ramay', 'Bobby', 'John', 'Tal', 'Gal', 'Tania', 'Elliot', 'Shir', 'Ayelet', 'Michal', 'Eilon', 'Ben-el', 'Tavori', 'Joseph', 'Mellie', 'Felecia', 'Jeanna', 'Beatris', 'Erlinda', 'Laticia', 'Jennefer', 'Juliane', 'Londa', 'Lacie', 'Beverly', 'Lashon', 'Estella', 'Marvel', 'Keitha', 'Douglas', 'Desmond', 'Yesenia', 'Eliseo', 'Arron', 'Joye', 'Lauren', 'Theresa', 'Lucie', 'Mee', 'Sandy', 'Leilani', 'Minna', 'Fredericka', 'Carin', 'Patrica', 'Sonia', 'Sherika', 'Gearldine', 'Deedee', 'Oren', 'Christeen', 'Myles', 'Ouida', 'Reggie', 'Georgia', 'Rosana', 'Dania', 'Debbi', 'Berenice', 'Trudy', 'Maurine', 'Oswaldo', 'Horacio', 'Florence'];
// tslint:disable-next-line:max-line-length
var words = ['Car', 'Bicycle', 'Elevator', 'Uncle', 'Dod', 'Coffe', 'Macbook', 'Bobs', 'Beer', 'Coffe', 'Pear', 'PhoneTel', 'baguios', 'tolly', 'preproven', 'creosotic', 'calandria', 'brothellike', 'insatiable', 'framableness', 'steelyard', 'unapproachability', 'unretaliating', 'kedah', 'gree', 'hydronaut', 'pathological', 'spunkier', 'subspecialize', 'subacetabular', 'halide', 'asteroidal', 'plenteous', 'laparectomy', 'infamousness', 'nondiffuse', 'miniaturist', 'outwriggle', 'raritan', 'bakeware', 'buss', 'tempting', 'unbrushable', 'rebop', 'nonsolicitous', 'slesvig', 'chlordane', 'dushehra', 'anabaptism', 'irreplacably', 'noncitation', 'croce', 'faucal', 'orkhon', 'lousiness', 'circumvallating', 'associability', 'yesilk', 'siliqua', 'steamy', 'overspecialize', 'lud', 'undersound', 'lave', 'tyrrheus', 'forgeries', 'cumae', 'corita', 'subminimal', 'fizzle', 'ochlocracy', 'basle', 'arries', 'entoblastic', 'macroevolution', 'westerville', 'saberlike', 'horsily', 'hierogrammatic', 'leipzig', 'muddiness', 'detonable', 'artistry', 'florance', 'polytypic', 'preembarrass', 'vanward', 'inoculating', 'paracelsian', 'xantippe', 'unimplicitly', 'waitress', 'reradiation', 'dieldrin', 'postventral', 'chuvash', 'muckraking', 'stibium', 'inswathe', 'paedogenesis', 'plodder', 'alluvium', 'intoxicable', 'checkered', 'paddler', 'laodicean', 'bleb', 'bestialised', 'negr', 'teazel', 'clarts', 'baguio'];
var countries = ['US', 'BR', 'RU', 'PL', 'ES', 'CG', 'SZ', 'SY', 'YE', 'IL'];
var pickRandom = function (l, without) {
    if (without === void 0) { without = []; }
    var filteredList = l.filter((function (i) { return !without.includes(i); }));
    var idx = Math.floor(filteredList.length * Math.random());
    return filteredList[idx];
};
export var generateMany = function (gen, count) {
    return Array.apply(null, Array(count))
        .map(gen);
};
var RandomGenerator = /** @class */ (function () {
    function RandomGenerator() {
    }
    RandomGenerator.randomLocale = function () {
        var letter1 = String.fromCharCode(RandomGenerator.randomNumber('a'.charCodeAt(0), 'z'.charCodeAt(0)));
        var letter2 = String.fromCharCode(RandomGenerator.randomNumber('a'.charCodeAt(0), 'z'.charCodeAt(0)));
        return letter1 + letter2;
    };
    RandomGenerator.randomLocales = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomLocale(); }, count);
    };
    RandomGenerator.id = function () {
        return uuid();
    };
    RandomGenerator.randomId = function () {
        return this.id();
    };
    RandomGenerator.randomString = function () {
        return this.randomWord();
    };
    RandomGenerator.randomCron = function () {
        var minutes = RandomGenerator.randomNumber(0, 59);
        var houres = RandomGenerator.randomNumber(0, 12);
        var dayOfMonth = RandomGenerator.randomNumber(1, 28);
        var dayOfWeek = RandomGenerator.randomNumber(0, 6);
        var isMonthly = RandomGenerator.randomBoolean();
        return isMonthly ? "".concat(minutes, " ").concat(houres, " ").concat(dayOfMonth, " * *") : "".concat(minutes, " ").concat(houres, " * * ").concat(dayOfWeek);
    };
    RandomGenerator.selectRandom = function (l, without) {
        if (without === void 0) { without = []; }
        return pickRandom(l, without);
    };
    RandomGenerator.randomDate = function () {
        return Date.now() - Math.floor(Math.random() * 1000 * 3600 * 24 * 31);
    };
    RandomGenerator.randomDates = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomDate(); }, count);
    };
    RandomGenerator.randomCountry = function () {
        return pickRandom(countries);
    };
    RandomGenerator.randomAutoRoutingSettings = function (maxWorkload, enabled) {
        var defaultChannelSettings = {
            maxSecondsToAccept: this.randomNumber(1),
            maxWorkload: maxWorkload || this.randomNumber(),
            enabled: enabled || !!this.randomNumber(0, 2),
        };
        return ({
            ticketing: defaultChannelSettings,
            facebook: defaultChannelSettings,
            chat: defaultChannelSettings,
            whatsapp: defaultChannelSettings,
            sms: defaultChannelSettings,
            twitter: defaultChannelSettings,
            instagram: defaultChannelSettings,
            groupIds: []
        });
    };
    RandomGenerator.randomAutoRoutingSupportedSettings = function (randomEnable, maxWorkload) {
        var enabled = randomEnable ? !!this.randomNumber(0, 2) : true;
        return ({
            autoRouting: this.randomAutoRoutingSettings(maxWorkload),
            callCenterSupported: !!enabled,
            knowledgebaseSupported: !!enabled,
            ticketingSupported: !!enabled,
            chatSupported: !!enabled,
            facebookSupported: !!enabled,
            whatsappSupported: !!enabled,
            smsSupported: !!enabled,
            instagramSupported: !!enabled,
            twitterSupported: !!enabled
        });
    };
    ;
    RandomGenerator.randomPhoneNumber = function () {
        return "+".concat(this.randomNumber(972000000000, 972999999999));
    };
    RandomGenerator.randomName = function () {
        return pickRandom(names) + this.randomNumber(1, 999999);
    };
    RandomGenerator.randomNumber = function (min, max) {
        if (min === void 0) { min = 1; }
        if (max === void 0) { max = min + 10; }
        return Math.floor((max - min) * Math.random() + min);
    };
    RandomGenerator.randomBoolean = function () {
        return Math.random() < 0.5;
    };
    // actual domain objects
    // TO BE REMOVED
    RandomGenerator.randomOldWidget = function () {
        return new OldWidgetBuilder().withId(uuid()).build();
    };
    // TO BE REMOVED
    RandomGenerator.randomOldWidgets = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomOldWidget(); }, count);
    };
    RandomGenerator.randomWidget = function () {
        return new WidgetBuilder()
            .withId(this.randomId())
            .withName(this.randomName())
            .withDescription(this.randomTextContent(1, 2))
            .build();
    };
    RandomGenerator.randomWidgets = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomWidget(); }, count);
    };
    RandomGenerator.randomWidgetAppearanceSettings = function () {
        var iconKeys = Object.keys(widgetIconKeys).map(function (i) { return widgetIconKeys[i]; });
        return new WidgetAppearanceSettingsBuilder()
            .withBrandColor(this.randomHexColor())
            .withTextColor(this.randomHexColor())
            .withIcon(iconKeys[Math.floor(Math.random() * iconKeys.length)])
            // .withBackgroundPatternUrl()
            // .withFont()
            .withPosition(this.randomNumber(1, this.getEnumLength(WidgetPosition)))
            .withTransition(this.randomNumber(1, this.getEnumLength(WidgetModuleTransition)))
            .withConvex(Math.random())
            .build();
    };
    RandomGenerator.group = function () {
        return new GroupBuilder()
            .withName(this.randomWord())
            .withId(this.randomId())
            .withMembersCount(this.randomNumber(0, 50))
            .build();
    };
    RandomGenerator.groups = function (count) {
        var _this = this;
        return generateMany(function () { return _this.group(); }, count);
    };
    RandomGenerator.randomTeam = function () {
        return {
            id: this.randomId(),
            name: this.randomString(),
            creationDate: this.randomDate(),
            lastUpdateDate: this.randomDate()
        };
    };
    RandomGenerator.randomTeams = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomTeam(); }, count);
    };
    RandomGenerator.userInfo = function () {
        var city = ['Tel Aviv', 'Moscow', 'Beer Sheva', 'Pitmaville', 'New Bobshire'][Math.floor(Math.random() * 5)];
        return new UserInfoBuilder().withCity(city).build();
    };
    RandomGenerator.randomExtendedBrandedTicket = function (randomLocale, brandId) {
        if (randomLocale === void 0) { randomLocale = false; }
        var ticket = (this.randomTicket(randomLocale));
        ticket.userInfo = this.userInfo();
        ticket.channelData = {};
        ticket.brandId = brandId;
        return ticket;
    };
    RandomGenerator.randomExtendedTicket = function (randomLocale) {
        if (randomLocale === void 0) { randomLocale = false; }
        var ticket = (this.randomTicket(randomLocale));
        ticket.userInfo = this.userInfo();
        ticket.channelData = {};
        return ticket;
    };
    RandomGenerator.randomTicketInfo = function (groupId, skillIds) {
        return new TicketInfoBuilder()
            .withId(this.randomId())
            .withSubject(this.randomString())
            .withUserInfo(this.userInfo())
            .withLocale(this.randomLocale())
            .withAssignedGroupId(groupId || this.randomId())
            .withSkillIds(skillIds || [this.randomId()])
            .build();
    };
    RandomGenerator.randomTicket = function (randomLocale) {
        if (randomLocale === void 0) { randomLocale = false; }
        var ticketBuilder = new TicketBuilder()
            .withId(this.randomId())
            .withSubject(this.randomTitle())
            .withUser(this.user());
        if (randomLocale) {
            ticketBuilder.withLocale(this.randomLocale());
        }
        return ticketBuilder.build();
    };
    RandomGenerator.tickets = function (count, randomLocale) {
        var _this = this;
        if (randomLocale === void 0) { randomLocale = false; }
        return Array.apply(null, Array(count))
            .map(function (_) { return _this.randomTicket(randomLocale); });
    };
    RandomGenerator.extendedTickets = function (count, randomLocale) {
        var _this = this;
        if (randomLocale === void 0) { randomLocale = false; }
        return Array.apply(null, Array(count))
            .map(function (_) { return _this.randomExtendedTicket(randomLocale); });
    };
    RandomGenerator.extendedBrandedTickets = function (count, brandId, randomLocale) {
        var _this = this;
        if (randomLocale === void 0) { randomLocale = false; }
        return Array.apply(null, Array(count))
            .map(function (_) { return _this.randomExtendedBrandedTicket(randomLocale, brandId); });
    };
    RandomGenerator.reply = function () {
        var content = this.randomTextContent(10);
        return new ReplyBuilder()
            .withId(this.randomId())
            .withContent(content)
            .withUser(this.user())
            .build();
    };
    RandomGenerator.replies = function (count) {
        var _this = this;
        return Array.apply(null, Array(count))
            .map(function (_) { return _this.reply(); });
    };
    RandomGenerator.note = function () {
        return new NoteBuilder()
            .withId(this.randomId())
            .withText(this.randomTextContent(10, 20))
            .withUser(this.user())
            .build();
    };
    RandomGenerator.notes = function (howManyNotes) {
        var _this = this;
        if (howManyNotes === void 0) { howManyNotes = 5; }
        return Array.apply(null, Array(howManyNotes))
            .map(function () { return _this.note(); });
    };
    RandomGenerator.savedReply = function () {
        return new SavedReplyBuilder()
            .withTitle(this.randomTitle())
            .withContent(this.randomTextContent(10, 20))
            .withAuthor(this.user())
            .withId(this.randomId())
            .build();
    };
    RandomGenerator.savedReplies = function (count) {
        var _this = this;
        return Array.apply(null, Array(count)).map(function (_) { return _this.savedReply(); });
    };
    RandomGenerator.randomMailbox = function () {
        var user = this.user();
        return new MailboxBuilder()
            .withId(this.id())
            .withEmail(user.email)
            .withName("".concat(user.firstName, ".").concat(user.lastName))
            .build();
    };
    RandomGenerator.randomAgentSlackChannelEmail = function () {
        return "".concat(this.randomString(), "@bob.slack.com");
    };
    RandomGenerator.randomMailboxesList = function (count) {
        var _this = this;
        return Array.apply(null, Array(count))
            .map(function () { return _this.randomMailbox(); });
    };
    RandomGenerator.randomFacebookPage = function () {
        return new FacebookPageBuilder()
            .withId(this.id())
            .withToken(this.id())
            .withName(this.randomName())
            .build();
    };
    RandomGenerator.randomFacebookPageData = function () {
        return new FacebookPageDataBuilder()
            .withId(this.id())
            .withToken(this.id())
            .build();
    };
    RandomGenerator.randomFacebookPagePlugin = function () {
        return new FacebookPagePluginBuilder()
            .withExternalKey(this.id())
            .withName(this.randomName())
            .withData(RandomGenerator.randomFacebookPageData())
            .build();
    };
    RandomGenerator.randomFacebookPagePluginList = function (count) {
        var _this = this;
        return Array.apply(null, Array(count))
            .map(function () { return _this.randomFacebookPagePlugin(); });
    };
    RandomGenerator.presenceInfo = function () {
        return new PresenceInfoBuilder()
            .withItemId(this.randomId())
            .withCreatedByUser(this.user())
            .withText(this.randomTitle()).build();
    };
    RandomGenerator.presenceInfoList = function (count) {
        var _this = this;
        return generateMany(function () { return _this.presenceInfo(); }, count);
    };
    RandomGenerator.randomApiKey = function () {
        var fakeSecret = this.randomId().replace(/-/g, '');
        return new ApiKeyBuilder().withId(this.randomId()).withTitle(this.randomTitle()).withSecret(fakeSecret).build();
    };
    RandomGenerator.randomApiKeys = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomApiKey(); }, count);
    };
    RandomGenerator.randomWebhook = function () {
        var randomUrlFriendlyWord = this.randomTextContent(2, 3).replace(/ /g, '-');
        // tslint:disable-next-line:max-line-length
        var type = [WebhookType.TICKET_CREATED, WebhookType.USER_REPLY_CREATED, WebhookType.SSO_USER_OUTDATED, WebhookType.TICKET_TRANSFERRED][Math.floor(Math.random() * 3)];
        var url = "http://www.".concat(randomUrlFriendlyWord, ".com");
        return new WebhookBuilder()
            .withId(this.randomId())
            .withName(this.randomTitle())
            .withType(type)
            .withUrl(url).build();
    };
    RandomGenerator.randomWebhooksList = function (count) {
        var _this = this;
        return Array.apply(null, Array(count)).map(function () { return _this.randomWebhook(); });
    };
    RandomGenerator.randomUri = function () {
        return "/".concat(this.randomTextContent(2, 4).replace(/ /g, '-'), "/");
    };
    RandomGenerator.randomUserNotification = function () {
        return new UserNotificationBuilder()
            .withUserId(this.id())
            .withContent(this.randomTextContent(5, 10))
            .withtype(Math.floor(this.randomNumber(0, 10)))
            .withuri(this.randomUri())
            .build();
    };
    RandomGenerator.randomUserNotificationList = function (count) {
        var _this = this;
        return Array.apply(null, Array(count))
            .map(function () {
            return _this.randomUserNotification();
        });
    };
    RandomGenerator.label = function () {
        return new LabelBuilder()
            .withId(this.randomId())
            .withName(this.randomWord())
            .build();
    };
    RandomGenerator.randomLabels = function (count) {
        var _this = this;
        return generateMany(function () { return _this.label(); }, count);
    };
    RandomGenerator.user = function (isAgent) {
        if (isAgent === void 0) { isAgent = false; }
        var firstName = this.randomName();
        var lastName = this.randomName();
        var fullName = "".concat(firstName, " ").concat(lastName);
        return new UserBuilder()
            .withPermissionLevel(isAgent ? PermissionLevel.AGENT : null)
            .withIsAgent(isAgent)
            .withUserId(this.id())
            .withUserEmail("".concat(firstName, ".").concat(lastName, "@gbob.com"))
            .withProfileImage(this.randomImage())
            .withFirstName(firstName)
            .withLastName(lastName)
            .withFullName(fullName)
            .withRoleId(this.randomString())
            .build();
    };
    RandomGenerator.dashboardUser = function (isAgent) {
        if (isAgent === void 0) { isAgent = false; }
        return {
            user: this.user(isAgent),
            numberOfTickets: this.randomNumber()
        };
    };
    RandomGenerator.users = function (count, isAgent) {
        var _this = this;
        if (isAgent === void 0) { isAgent = false; }
        return generateMany(function () { return _this.user(isAgent); }, count);
    };
    RandomGenerator.dashboardUsers = function (count, isAgent) {
        var _this = this;
        if (isAgent === void 0) { isAgent = false; }
        return generateMany(function () { return _this.dashboardUser(isAgent); }, count);
    };
    RandomGenerator.callParticipant = function (isAgent) {
        if (isAgent === void 0) { isAgent = false; }
        var randomCallParticipantStatus = pickRandom([
            CallParticipantStatus.CONNECTING,
            CallParticipantStatus.DECLINED,
            CallParticipantStatus.LEFT,
            CallParticipantStatus.MUTED,
            CallParticipantStatus.NO_ANSWER,
            CallParticipantStatus.ON_HOLD,
            CallParticipantStatus.TALKING
        ]);
        return __assign(__assign({}, this.user(isAgent)), { status: randomCallParticipantStatus, statusLastUpdateDate: this.randomDate() });
    };
    RandomGenerator.callParticipants = function (count, isAgent) {
        var _this = this;
        if (isAgent === void 0) { isAgent = false; }
        return generateMany(function () { return _this.callParticipant(isAgent); }, count);
    };
    RandomGenerator.category = function (children, locale) {
        if (children === void 0) { children = []; }
        if (locale === void 0) { locale = 'en'; }
        return new CategoryBuilder()
            .withId(this.id())
            .withLang(locale)
            .withName(this.randomWord())
            .withChildren(children).
            withHasPublishedArticleDescendant(true)
            .build();
    };
    RandomGenerator.extendedCategory = function (children, locale) {
        if (children === void 0) { children = []; }
        if (locale === void 0) { locale = 'en'; }
        return new ExtendedCategoryBuilder()
            .withId(this.id())
            .withLang(locale)
            .withName(this.randomWord())
            .withChildren(children)
            .withDraftArticleCount(this.randomNumber(0, 10))
            .withPublishedArticleCount(this.randomNumber(0, 10)).
            withHasPublishedArticleDescendant(true)
            .build();
    };
    // tslint:disable-next-line:max-line-length
    RandomGenerator.adminCategoryTree = function (howManyCategories, subsCatPerCategory, locale) {
        var _this = this;
        if (howManyCategories === void 0) { howManyCategories = 10; }
        if (subsCatPerCategory === void 0) { subsCatPerCategory = 0; }
        if (locale === void 0) { locale = 'en'; }
        return generateMany(function () {
            var children = generateMany(function () { return _this.extendedCategory([], locale); }, subsCatPerCategory);
            return _this.extendedCategory(children, locale);
        }, howManyCategories);
    };
    // tslint:disable-next-line:max-line-length
    RandomGenerator.randomCategoryTreeMultiLevel = function (howManyCategoriesPerLevel, levels, parentId) {
        var _this = this;
        if (howManyCategoriesPerLevel === void 0) { howManyCategoriesPerLevel = 1; }
        if (levels === void 0) { levels = 1; }
        if (parentId === void 0) { parentId = '000'; }
        var res = this.randomExtendedCategoryTree(howManyCategoriesPerLevel);
        res = res.map(function (cat) {
            cat.draftArticleCount = 0;
            cat.publishedArticleCount = 0;
            cat.parentId = parentId;
            if (levels > 1) {
                cat.children = _this.randomCategoryTreeMultiLevel(howManyCategoriesPerLevel, levels - 1, cat.id);
            }
            ;
            return cat;
        });
        return res;
    };
    // tslint:disable-next-line:max-line-length
    RandomGenerator.randomCategoryTree = function (howManyCategories, subsCatPerCategory, locale) {
        var _this = this;
        if (howManyCategories === void 0) { howManyCategories = 10; }
        if (subsCatPerCategory === void 0) { subsCatPerCategory = 0; }
        if (locale === void 0) { locale = 'en'; }
        return generateMany(function () {
            var children = generateMany(function () { return _this.category([], locale); }, subsCatPerCategory);
            return _this.category(children, locale);
        }, howManyCategories);
    };
    RandomGenerator.randomExtendedCategoryTree = function (howManyCategories, subsCatPerCategory, locale) {
        var _this = this;
        if (howManyCategories === void 0) { howManyCategories = 10; }
        if (subsCatPerCategory === void 0) { subsCatPerCategory = 0; }
        if (locale === void 0) { locale = 'en'; }
        return generateMany(function () {
            var children = generateMany(function () { return _this.extendedCategory([], locale); }, subsCatPerCategory);
            return _this.extendedCategory(children, locale);
        }, howManyCategories);
    };
    RandomGenerator.remoteFile = function () {
        var date = Date.now() - Math.floor(Math.random() * 3600 * 24 * 31);
        return new RemoteFileBuilder()
            .withUrl(this.randomUri())
            .withName(this.randomName())
            .withClient(AnswersClients.helpcenter)
            .withLastUpdateDate(new Date(date))
            .build();
    };
    RandomGenerator.remoteFiles = function (count) {
        var _this = this;
        return generateMany(function () { return _this.remoteFile(); }, count);
    };
    RandomGenerator.task = function (mixedStatuses) {
        if (mixedStatuses === void 0) { mixedStatuses = false; }
        var createdByUser = this.user();
        var completedByUser;
        var assignedUser = this.user();
        var status = mixedStatuses ? TsUtils.randomEnumValue(ContentTaskStatus) : ContentTaskStatus.OPEN;
        if (status === ContentTaskStatus.COMPLETED) {
            completedByUser = this.user();
        }
        return new ContentTaskBuilder()
            .withDescription(this.randomTextContent())
            .withId(this.id())
            .withAssignedByUser(assignedUser)
            .withCreatedByUser(createdByUser)
            .withStatus(status)
            .withCompletedByUser(completedByUser)
            .withCompletionDate(completedByUser ? Date.now() - 12 * 3600000 : undefined)
            .withType(TsUtils.randomEnumValue(ContentTaskType))
            .withPriority(TsUtils.randomEnumValue(ContentTaskPriority))
            .build();
    };
    RandomGenerator.randomTasks = function (count, mixedStatuses) {
        var _this = this;
        if (mixedStatuses === void 0) { mixedStatuses = false; }
        return generateMany(function () { return _this.task(mixedStatuses); }, count);
    };
    RandomGenerator.randomResolvedCustomField = function () {
        var _this = this;
        var fieldType = TsUtils.randomEnumValue(CustomFieldType);
        var mandatory = [true, false][Math.floor(Math.random() * 2)];
        var values = generateMany(function () { return _this.randomWord(); }, this.randomNumber(1, 10));
        var data = new CustomFieldLocaleDataBuilder()
            .withTitle(this.randomTitle())
            .withPlaceholder(this.randomWord())
            .withDescription(this.randomWord())
            .withValues(values)
            .build();
        return new ResolvedCustomFieldBuilder()
            .withId(this.randomId())
            .withType(fieldType)
            .withMandatory(mandatory)
            .withName(this.randomWord())
            .withData(data)
            .build();
    };
    RandomGenerator.customField = function (locale) {
        var _a;
        if (locale === void 0) { locale = 'en'; }
        return {
            id: this.randomId(),
            lastUpdateDate: Date.now(),
            creationDate: Date.now(),
            name: this.randomName(),
            displayName: this.randomName(),
            type: CustomFieldType.TEXT,
            itemType: ItemType.TICKET,
            data: {
                multilingualData: (_a = {},
                    _a[locale] = {
                        title: this.randomString(),
                        translatedTitles: {},
                        placeHolder: this.randomString(),
                        values: [],
                        description: this.randomString(),
                        disabled: false,
                    },
                    _a),
                deletedValues: {}
            }
        };
    };
    RandomGenerator.customFields = function (count, locale) {
        var _this = this;
        if (locale === void 0) { locale = 'en'; }
        return generateMany(function () { return _this.customField(locale); }, count);
    };
    RandomGenerator.randomResolvedCustomFields = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomResolvedCustomField(); }, count);
    };
    RandomGenerator.randomSimpleCustomField = function (partialValues) {
        var _this = this;
        var values = generateMany(function () { return _this.randomWord(); }, this.randomNumber(1, 10));
        var data = {
            data: {
                description: this.randomWord(),
                title: this.randomName(),
                translatedTitles: {},
                disabled: false,
                placeHolder: '',
                values: values
            }
        };
        return new SimpleCustomFieldBuilder()
            .withId(partialValues && partialValues.id ? partialValues.id : this.randomId())
            .withType(partialValues && partialValues.type ? partialValues.type : CustomFieldType.TEXT)
            .withName(partialValues && partialValues.name ? partialValues.name : this.randomWord())
            .withData(data)
            .withDisplayName(partialValues && partialValues.displayName ? partialValues.displayName : this.randomWord())
            .build();
    };
    RandomGenerator.randomSimpleCustomFields = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomSimpleCustomField(); }, count);
    };
    RandomGenerator.randomSimpleCustomFieldByType = function (type, itemType, dataValues) {
        var cf = new SimpleCustomFieldBuilder().withId(RandomGenerator.id()).withType(type).withItemType(itemType);
        var maybeWithDataValues = dataValues ? cf.withDataValues(dataValues) : cf;
        return maybeWithDataValues.build();
    };
    RandomGenerator.randomCustomFieldByType = function (type, dataValues) {
        var cf = new CustomFieldBuilder().withId(RandomGenerator.id()).withType(type);
        var data = dataValues && new CustomFieldLocaleDataBuilder().withValues(dataValues).build();
        var maybeWithData = data ? cf.withData({ multilingualData: { en: data }, deletedValues: {} }) : cf;
        return maybeWithData.build();
    };
    RandomGenerator.randomItemTypeCustomField = function (cfType, dataValues) {
        var itemTypes = [ItemType.TICKET, ItemType.COMPANY, ItemType.USER, ItemType.AGENT];
        var maybeExcludeTicketType = cfType === CustomFieldType.MULTI_SELECT ? [ItemType.TICKET] : [];
        var randomItemType = function () { return RandomGenerator.selectRandom(itemTypes, maybeExcludeTicketType); };
        var randomType = randomItemType();
        return randomType === ItemType.TICKET ?
            this.randomCustomFieldByType(cfType, dataValues) :
            this.randomSimpleCustomFieldByType(cfType, randomType, dataValues);
    };
    RandomGenerator.randomQueue = function () {
        return new QueueBuilder()
            .withId(this.randomId())
            .withName(this.randomWord())
            .withDescription(this.randomWord())
            .withTotalAssignees(this.randomNumber(1, 10))
            .withLocale(this.randomLocale())
            .withDefault(false)
            .withCreationDate(this.randomDate())
            .withLastUpdateDate(this.randomDate())
            .build();
    };
    RandomGenerator.randomQueues = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomQueue(); }, count);
    };
    RandomGenerator.randomQueueStats = function () {
        return new QueueStatsBuilder()
            .withId(this.randomId())
            .withName(this.randomWord())
            .withLocale(this.randomLocale())
            .build();
    };
    RandomGenerator.randomQueuesStats = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomQueueStats(); }, count);
    };
    RandomGenerator.randomSkills = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomSkill(); }, count);
    };
    RandomGenerator.randomProductSkills = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomProductSkill(); }, count);
    };
    RandomGenerator.randomSkill = function () {
        return new SkillBuilder()
            .withId(this.randomId())
            .withName(this.randomName())
            .withCreationDate(this.randomDate())
            .withLastUpdateDate(this.randomDate())
            .build();
    };
    RandomGenerator.randomProductSkill = function () {
        return new SkillBuilder()
            .withId(this.randomId())
            .withType(SkillType.PRODUCT_SKILL)
            .withName(this.randomWord())
            .withCreationDate(this.randomDate())
            .withLastUpdateDate(this.randomDate())
            .build();
    };
    RandomGenerator.randomSoftSkill = function () {
        return new SkillBuilder()
            .withId(this.randomId())
            .withType(SkillType.SOFT_SKILL)
            .withName(this.randomWord())
            .withCreationDate(this.randomDate())
            .withLastUpdateDate(this.randomDate())
            .build();
    };
    RandomGenerator.randomLine = function () {
        return new LineBuilder()
            .withId(this.randomId())
            .withName(this.randomWord())
            .withDescription(this.randomWord())
            .withPhoneNumber(this.randomPhoneNumber())
            .withCreationDate(this.randomDate())
            .withLastUpdateDate(this.randomDate())
            .build();
    };
    RandomGenerator.randomLines = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomLine(); }, count);
    };
    RandomGenerator.randomCallCenterAgent = function () {
        var randomDate = this.randomDate();
        var firstName = this.randomName();
        var lastName = this.randomName();
        return new CallCenterAgentBuilder()
            .withUserId(this.randomId())
            .withFirstName(firstName)
            .withLastName(lastName)
            .withFullName("".concat(firstName, " ").concat(lastName))
            .withProfileImage(this.randomImage())
            .withLocation(pickRandom(['MI', 'SF', 'TLV']))
            .withStatus(TsUtils.randomEnumValue(CallCenterAgentStatus))
            .withActiveCallId(this.randomId())
            .withStatusStartDate(randomDate)
            .withAvgCallDurationSec(this.randomNumber(10, 3600))
            .withCallsCount(this.randomNumber(0, 60))
            .withShiftStartDate(randomDate - 3600)
            .withTotalTimeBusySec(this.randomNumber(0, 3600))
            .withTimesBusy(this.randomNumber(0, 60))
            .build();
    };
    RandomGenerator.randomCallCenterAgents = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomCallCenterAgent(); }, count);
    };
    RandomGenerator.callStats = function () {
        var randomStatus = pickRandom([
            ExtendedCallStatus.IN_QUEUE,
            ExtendedCallStatus.IN_PROGRESS,
            ExtendedCallStatus.COMPLETED,
            ExtendedCallStatus.NO_ANSWER
        ]);
        var country = this.randomCountry().toUpperCase();
        var userPhoneNumber = {
            countryCode: "".concat(country[0]).concat(country[1]),
            number: "".concat(this.randomNumber(0, 9999999))
        };
        var participants = [
            this.callParticipant(pickRandom([true, false])),
            this.callParticipant(pickRandom([true, false])),
            this.callParticipant(pickRandom([true, false])),
        ];
        return new CallStatsBuilder()
            .withId(this.randomId())
            .withQueueId(this.randomId())
            .withUser(this.user())
            .withTicket(this.randomTicketInfo())
            .withStatus(randomStatus)
            .withUserPhoneNumber(userPhoneNumber)
            .withParticipants(participants)
            .withPriorityScore(this.randomNumber(0, 100))
            .build();
    };
    RandomGenerator.callsStats = function (count) {
        var _this = this;
        return generateMany(function () { return _this.callStats(); }, count);
    };
    RandomGenerator.webNotification = function () {
        return new WebNotificationBuilder()
            .withId(this.randomId())
            .withCreatedByUser(this.user())
            .withCreationDate(this.randomDate())
            .withRead(pickRandom([true, false]))
            .withUrgent(pickRandom([true, false]))
            .withType(TsUtils.randomEnumValue(WebNotificationType))
            .build();
    };
    RandomGenerator.webNotifications = function (count) {
        var _this = this;
        return generateMany(function () { return _this.webNotification(); }, count).sort(function (a, b) { return b.creationDate - a.creationDate; });
    };
    RandomGenerator.agent = function () {
        var user = this.user(true);
        var channels = {
            callCenterEnabled: !!RandomGenerator.randomNumber(0, 2),
            chat: { enabled: !!RandomGenerator.randomNumber(0, 2), maxWorkload: RandomGenerator.randomNumber(1, 10) },
            facebook: { enabled: !!RandomGenerator.randomNumber(0, 2), maxWorkload: RandomGenerator.randomNumber(1, 10) },
            twitter: { enabled: !!RandomGenerator.randomNumber(0, 2), maxWorkload: RandomGenerator.randomNumber(1, 10) },
            instagram: { enabled: RandomGenerator.randomBoolean(), maxWorkload: RandomGenerator.randomNumber(1, 10) },
            knowledgebaseEnabled: !!RandomGenerator.randomNumber(0, 2),
            ticketing: { enabled: !!RandomGenerator.randomNumber(0, 2), maxWorkload: RandomGenerator.randomNumber(1, 10) },
            whatsapp: { enabled: !!RandomGenerator.randomNumber(0, 2), maxWorkload: RandomGenerator.randomNumber(1, 10) },
            sms: { enabled: !!RandomGenerator.randomNumber(0, 2), maxWorkload: RandomGenerator.randomNumber(1, 10) },
        };
        var enabledChannels = [];
        enabledChannels.concat(channels.callCenterEnabled ? ["".concat(SupportedFeatures.CALL_CENTER)] : []);
        enabledChannels.concat(channels.chat.enabled ? ["".concat(SupportedFeatures.CHAT)] : []);
        enabledChannels.concat(channels.facebook.enabled ? ["".concat(SupportedFeatures.FACEBOOK)] : []);
        enabledChannels.concat(channels.twitter.enabled ? ["".concat(SupportedFeatures.TWITTER)] : []);
        enabledChannels.concat(channels.knowledgebaseEnabled ? ["".concat(SupportedFeatures.KNOWLEDGEBASE)] : []);
        enabledChannels.concat(channels.ticketing.enabled ? ["".concat(SupportedFeatures.TICKETING)] : []);
        enabledChannels.concat(channels.whatsapp.enabled ? ["".concat(SupportedFeatures.WHATSAPP)] : []);
        enabledChannels.concat(channels.sms.enabled ? ["".concat(SupportedFeatures.SMS)] : []);
        var agentAutoRoutingSettings = __assign(__assign({}, channels), { enabledChannels: enabledChannels });
        var agent = new AgentBuilder()
            .withLocation(pickRandom(['MI', 'SF', 'TLV']))
            .withRoleId(this.randomString())
            .withJobTitle(this.randomString())
            .withGroupIds([this.randomString()])
            .withTeamId(this.randomString())
            .withLocationId(this.randomString())
            .withChannel(TsUtils.randomEnumValue(AgentChannel))
            .withQualifiedChannels([TsUtils.randomEnumValue(AgentChannel)])
            .withQueueIds([this.randomString()])
            .withAutoRoutingSettings(agentAutoRoutingSettings)
            .withSlackChannel(RandomGenerator.randomAgentSlackChannelEmail())
            .build();
        return __assign(__assign({}, agent), user);
    };
    RandomGenerator.agents = function (count) {
        var _this = this;
        return generateMany(function () { return _this.agent(); }, count);
    };
    RandomGenerator.article = function () {
        return new ArticleBuilder()
            .withId(this.id())
            .withTitle(this.randomTitle())
            .withUri("/article/some-uri-" + this.randomNumber(1, 999))
            .build();
    };
    RandomGenerator.articles = function (count) {
        var _this = this;
        return generateMany(function () { return _this.article(); }, count)
            .map(function (art, idx) { return (__assign(__assign({}, art), { title: art.title + "".concat(idx) })); });
    };
    RandomGenerator.extendedArticle = function () {
        return new ExtendedArticleBuilder()
            .withResolution(this.randomArticleResolution())
            .withType(this.randomArticleType())
            .withId(this.id())
            .withTitle(this.randomTitle())
            .build();
    };
    RandomGenerator.extendedArticles = function (count) {
        var _this = this;
        return generateMany(function () { return _this.extendedArticle(); }, count);
    };
    RandomGenerator.macro = function () {
        return new MacroBuilder()
            .withName(this.randomName())
            .withDescription(this.randomName())
            .withId(this.id())
            .build();
    };
    RandomGenerator.macros = function (count) {
        var _this = this;
        return generateMany(function () { return _this.macro(); }, count);
    };
    RandomGenerator.userRole = function () {
        return new UserRoleBuilder()
            .withName(this.randomName())
            .withDescription(this.randomName())
            .withId(this.id())
            .build();
    };
    RandomGenerator.userRoles = function (count) {
        var _this = this;
        return generateMany(function () { return _this.userRole(); }, count);
    };
    RandomGenerator.userRoleInfo = function () {
        return new RoleInfoBuilder()
            .withName(this.randomName())
            .withDescription(this.randomName())
            .withId(this.id())
            .build();
    };
    RandomGenerator.userRolesInfo = function (count) {
        var _this = this;
        return generateMany(function () { return _this.userRoleInfo(); }, count);
    };
    RandomGenerator.companyInfo = function () {
        return {
            logo: this.randomImage(),
            description: this.randomTextContent(10, 20)
        };
    };
    RandomGenerator.companiesInfo = function (count) {
        var _this = this;
        return generateMany(function () { return _this.companyInfo(); }, count);
    };
    RandomGenerator.companyDisplayInfo = function () {
        return {
            logo: this.randomImage(),
            name: this.randomName(),
            id: RandomGenerator.id()
        };
    };
    RandomGenerator.companiesDisplayIfo = function (count) {
        var _this = this;
        return generateMany(function () { return _this.companyDisplayInfo(); }, count);
    };
    RandomGenerator.companyEmailDomainSettings = function () {
        return {
            autoAssociateUsers: this.randomNumber(1, 10) % 2 === 0,
            emailDomains: [this.domain()]
        };
    };
    RandomGenerator.company = function () {
        var name = this.randomName();
        var accountManager = this.agent();
        var date = new Date(this.randomDate());
        var emailSettings = this.companyEmailDomainSettings();
        var info = this.companyInfo();
        return new CompanyBuilder()
            .withId(this.randomId())
            .withName(name)
            .withAccountManager(accountManager)
            .withEmailDomainSettings(emailSettings)
            .withInfo(info)
            .withCreationDate(date)
            .build();
    };
    RandomGenerator.companies = function (count) {
        var _this = this;
        return generateMany(function () { return _this.company(); }, count);
    };
    RandomGenerator.locations = function (count) {
        return generateMany(function () { return ({
            id: RandomGenerator.id(),
            name: RandomGenerator.randomName(),
            creationDate: Date.now(),
            lastUpdateDate: Date.now(),
        }); }, count);
    };
    RandomGenerator.articleActivityEvent = function () {
        return new ActivityEventBuilder()
            .withCreationDate(this.randomDate())
            .withId(this.randomId())
            .withItemId(this.randomId())
            .withItemType(ItemType.ARTICLE)
            .withUser(this.user())
            .withEventType(this.randomArticleActivityEvent())
            .build();
    };
    RandomGenerator.articleActivityEvents = function (count) {
        var _this = this;
        return generateMany(function () { return _this.articleActivityEvent(); }, count);
    };
    RandomGenerator.articleVersion = function () {
        return new ArticleVersionBuilder()
            .withContent({ content: this.randomString(), title: this.randomString() })
            .withCreatedByUser(this.user())
            .withCreationDate(this.randomDate())
            .withId(this.id())
            .withLastUpdateDate(this.randomDate())
            .withPublicationStatus(this.randomNumber(0, 1) ? PublicationStatus.DRAFT : PublicationStatus.PUBLISHED)
            .build();
    };
    RandomGenerator.articleVersions = function (count) {
        var _this = this;
        return generateMany(function () { return _this.articleVersion(); }, count);
    };
    RandomGenerator.articleTranslation = function (withoutDelete) {
        return {
            title: RandomGenerator.randomString(),
            url: RandomGenerator.randomUri(),
            locale: RandomGenerator.randomLocale(),
            status: this.randomNumber(0, 1) || withoutDelete ?
                this.randomNumber(0, 1) ? ArticleStatus.PUBLISHED : ArticleStatus.DRAFT
                : ArticleStatus.DELETED
        };
    };
    RandomGenerator.articleTranslations = function (count, withoutDelete) {
        var _this = this;
        return generateMany(function () { return _this.articleTranslation(withoutDelete); }, count);
    };
    RandomGenerator.callStatsStatus = function (excludeStatuses) {
        return this.selectRandom(TsUtils.enumToArray(CallStatsStatus, function (key) { return !(excludeStatuses === null || excludeStatuses === void 0 ? void 0 : excludeStatuses.includes(CallStatsStatus[key])); }));
    };
    RandomGenerator.channel = function (excludeChannel) {
        return this.selectRandom(TsUtils.enumToArray(Channel, function (key) { return !(excludeChannel === null || excludeChannel === void 0 ? void 0 : excludeChannel.includes(Channel[key])); }));
    };
    RandomGenerator.ticketStatus = function (excludeStatuses) {
        return this.selectRandom(TsUtils.enumToArray(TicketStatus, function (key) { return !(excludeStatuses === null || excludeStatuses === void 0 ? void 0 : excludeStatuses.includes(TicketStatus[key])); }));
    };
    RandomGenerator.ticketSessionStatus = function (excludeSessionStatuses) {
        return this.selectRandom(TsUtils.enumToArray(TicketSessionStatus, function (key) { return !(excludeSessionStatuses === null || excludeSessionStatuses === void 0 ? void 0 : excludeSessionStatuses.includes(TicketSessionStatus[key])); }));
    };
    RandomGenerator.ticketPriority = function (excludePriorities) {
        return this.selectRandom(TsUtils.enumToArray(TicketPriority, function (key) { return !(excludePriorities === null || excludePriorities === void 0 ? void 0 : excludePriorities.includes(TicketPriority[key])); }));
    };
    RandomGenerator.callCenterAgentStatus = function (excludeStatuses) {
        return this.selectRandom(TsUtils.enumToArray(CallCenterAgentStatus, function (key) { return !(excludeStatuses === null || excludeStatuses === void 0 ? void 0 : excludeStatuses.includes(CallCenterAgentStatus[key])); }));
    };
    RandomGenerator.agentGlobalStatus = function (excludeStatuses) {
        return this.selectRandom(TsUtils.enumToArray(AgentStatusFilterOptions, function (key) { return !(excludeStatuses === null || excludeStatuses === void 0 ? void 0 : excludeStatuses.includes(AgentStatusFilterOptions[key])); }));
    };
    RandomGenerator.activityType = function (excludeActivityTypes) {
        return this.selectRandom(TsUtils.enumToArray(ActivityType, function (key) { return !(excludeActivityTypes === null || excludeActivityTypes === void 0 ? void 0 : excludeActivityTypes.includes(ActivityType[key])); }));
    };
    RandomGenerator.randomArticleTextComponent = function () {
        return {
            key: this.randomString(),
            type: 'text',
            value: { html: this.randomString() }
        };
    };
    RandomGenerator.randomArticleEmptyTextComponent = function () {
        return {
            key: this.randomString(),
            type: 'text',
            value: { html: '<div><br></div>' }
        };
    };
    RandomGenerator.randomComment = function (resolved, removeCreatedByUser) {
        if (resolved === void 0) { resolved = false; }
        return {
            articleId: this.randomId(),
            content: this.randomString(),
            creationDate: this.randomDate(),
            id: this.randomId(),
            lastUpdateDate: this.randomDate(),
            locale: this.randomLocale(),
            number: this.randomNumber(1, 1000),
            participants: {
                mentionedAgents: [],
                mentioningAgents: [],
                all: [],
            },
            repliesCount: this.randomNumber(0, 100),
            resolved: resolved,
            lastResolveDate: this.randomDate(),
            resolvedBy: new AgentBuilder().build(),
            createdBy: removeCreatedByUser ? undefined : new AgentBuilder().build(),
        };
    };
    RandomGenerator.randomCommentReply = function () {
        return {
            content: this.randomString(),
            creationDate: this.randomDate(),
            id: this.randomId(),
            createdBy: new AgentBuilder().build(),
            commentId: this.randomId(),
        };
    };
    RandomGenerator.schedule = function () {
        return tenantScheduleBuilder({
            id: this.randomId(),
            name: this.randomString(),
            description: this.randomString(),
        });
    };
    RandomGenerator.schedules = function (count) {
        var _this = this;
        return generateMany(function () { return _this.schedule(); }, count);
    };
    RandomGenerator.brand = function () {
        return new BrandBuilder()
            .withCreationDate(this.randomDate())
            .withId(this.randomId())
            .withName(this.randomString())
            .withEnabled(!this.randomNumber(0, 2))
            .withHcEnabled(!this.randomNumber(0, 2))
            .build();
    };
    RandomGenerator.brands = function (count) {
        var _this = this;
        return generateMany(function () { return _this.brand(); }, count);
    };
    RandomGenerator.randomTicketPriority = function () {
        return TsUtils.randomEnumValue(TicketPriority);
    };
    RandomGenerator.scheduleDownTime = function (scheduleId) {
        var startDate = new Date().getTime() + Math.floor((Math.random() * 100000) + 5001); // 5,000-100,000
        var endDate = startDate + Math.floor((Math.random() * 100000) + 5001);
        return downTimeBuilder({
            startDate: startDate,
            endDate: endDate,
            name: this.randomString(),
            id: this.randomId(),
            scheduleId: scheduleId || this.randomId(),
        });
    };
    RandomGenerator.scheduleDownTimes = function (count, scheduleId) {
        var _this = this;
        return generateMany(function () { return _this.scheduleDownTime(scheduleId); }, count);
    };
    RandomGenerator.createRandomInstagramAccount = function () {
        return new InstagramAccountBuilder().build();
    };
    RandomGenerator.createRandomInstagramAccounts = function (amount) {
        var data = {
            directMessageEnabled: RandomGenerator.randomBoolean(),
            profileImage: 'https://picsum.photos/200/300'
        };
        return generateMany(function () { return new InstagramAccountBuilder().withData(data).build(); }, amount);
        ;
    };
    RandomGenerator.randomAutoRoutingAssignment = function () {
        return new AutoRoutingAssignmentBuilder()
            .withId(RandomGenerator.randomId())
            .withTenantId(RandomGenerator.randomId())
            .withTicketId(RandomGenerator.randomId())
            .withChannel(TsUtils.randomEnumValue(Channel))
            .withActivityType(TsUtils.randomEnumValue(ActivityType))
            .withUser(RandomGenerator.user())
            .withStatus(TsUtils.randomEnumValue(AutoRoutingAssignmentStatus))
            .withCreationDate(RandomGenerator.randomDate())
            .withLastUpdateDate(RandomGenerator.randomDate())
            .build();
    };
    RandomGenerator.randomAutoRoutingAssignments = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomAutoRoutingAssignment(); }, count);
    };
    RandomGenerator.randomTicketSummary = function () {
        return {
            itemId: this.randomId(),
            itemType: TicketSummaryChannel.CALL,
            summarizedIssues: [{
                    agentFindings: this.randomTextContent(),
                    agentSolution: this.randomTextContent(),
                    userIssue: this.randomTextContent(),
                    stepsToReproduce: [this.randomTextContent()],
                }]
        };
    };
    // internal utils
    RandomGenerator.getEnumLength = function (enumObj) {
        return Object.keys(enumObj).filter(function (i) { return typeof enumObj[i] === 'number'; }).length;
    };
    RandomGenerator.randomWord = function () {
        return "".concat(pickRandom(words), "-").concat(this.randomNumber(10, 999999));
    };
    RandomGenerator.randomTitle = function () {
        return randomTitle(1)[0];
    };
    RandomGenerator.randomImage = function () {
        return 'data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEVBMTczNDg3QzA5MTFFNjk3ODM5NjQyRjE2RjA3QTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEVBMTczNDk3QzA5MTFFNjk3ODM5NjQyRjE2RjA3QTkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowRUExNzM0NjdDMDkxMUU2OTc4Mzk2NDJGMTZGMDdBOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRUExNzM0NzdDMDkxMUU2OTc4Mzk2NDJGMTZGMDdBOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjjUmssAAAGASURBVHjatJaxTsMwEIbpIzDA6FaMMPYJkDKzVYU+QFeEGPIKfYU8AETkCYI6wANkZQwIKRNDB1hA0Jrf0rk6WXZ8BvWkb4kv99vn89kDrfVexBSYgVNwDA7AN+jAK3gEd+AlGMGIBFDgFvzouK3JV/lihQTOwLtOtw9wIRG5pJn91Tbgqk9kSk7GViADrTD4HCyZ0NQnomi51sb0fUyCMQEbp2WpU67IjfNjwcYyoUDhjJVcZBjYBy40j4wXgaobWoe8Z6Y80CJBwFpunepIzt2AUgFjtXXshNXjVmMh+K+zzp/CMs0CqeuzrxSRpbOKfdCkiMTS1VBQ41uxMyQR2qbrXiiwYN3ACh1FDmsdK2Eu4J6Tlo31dYVtCY88h5ELZIJJ+IRMzBHfyJINrigNkt5VsRiub9nXICdsYyVd2NcVvA3ScE5t2rb5JuEeyZnAhmLt9NK63vX1O5Pe8XaPSuGq1uTrfUgMEp9EJ+CQvr+BJ/AAKvAcCiAR+bf9CjAAluzmdX4AEIIAAAAASUVORK5CYII=';
    };
    RandomGenerator.randomTextContent = function (min, max) {
        if (min === void 0) { min = 5; }
        if (max === void 0) { max = 15; }
        return loremParts.slice(min, max).join(' ');
    };
    RandomGenerator.randomHexColor = function () {
        return '#' + ('000000' + Math.random().toString(16).slice(2, 8).toUpperCase()).slice(-6);
    };
    RandomGenerator.domain = function () {
        var postfix = ['.com', '.net', '.org', '.io', '.co.il', '.co.uk'];
        return this.randomName() + postfix[this.randomNumber(0, postfix.length - 1)];
    };
    RandomGenerator.randomArticleResolution = function () {
        return TsUtils.randomEnumValue(ArticleResolution);
    };
    RandomGenerator.randomArticleType = function () {
        var validArticleTypes = TsUtils.enumToArray(ArticleType).filter(function (type) { return type !== ArticleType.VIDEO; });
        return validArticleTypes[this.randomNumber(0, validArticleTypes.length - 1)];
    };
    RandomGenerator.randomArticleActivityEvent = function () {
        var articleActivityEvents = TsUtils.enumToArray(ActivityEventType, function (key) { return key.toLowerCase().startsWith('ARTICLE'); });
        return articleActivityEvents[this.randomNumber(0, articleActivityEvents.length - 1)];
    };
    RandomGenerator.randomContentSnippet = function () {
        return {
            id: this.randomId(),
            name: this.randomString(),
            description: this.randomString(),
            locale: this.randomLocale(),
            shortcut: "#".concat(pickRandom(words)),
            content: "<div>".concat(this.randomString(), "</div>"),
            usageCount: this.randomNumber(),
            createdBy: this.user(),
            lastUpdatedBy: this.user(),
            creationDate: this.randomDate(),
            lastUpdateDate: this.randomDate(),
        };
    };
    RandomGenerator.randomContentSnippets = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomContentSnippet(); }, count);
    };
    RandomGenerator.randomRoutingRuleFilter = function () {
        var filterType = this.selectRandom(TsUtils.enumToArray(RoutingFilterType));
        var filterValues = [this.randomString()];
        return routingFilterBuilder({ filterType: filterType, filterValues: filterValues });
    };
    RandomGenerator.randomRoutingRuleFilters = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomRoutingRuleFilter(); }, count);
    };
    RandomGenerator.randomRoutingRule = function () {
        return {
            id: this.randomId(),
            name: this.randomString(),
            filters: { filters: [] },
            targetGroupId: this.randomId(),
            creationDate: this.randomDate(),
            lastUpdateDate: this.randomDate(),
            position: this.randomNumber(),
        };
    };
    RandomGenerator.randomRoutingRules = function (count) {
        var _this = this;
        return generateMany(function () { return _this.randomRoutingRule(); }, count);
    };
    return RandomGenerator;
}());
export { RandomGenerator };
//# sourceMappingURL=index.js.map